import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Instagram, Twitter, ArrowUpRight } from "lucide-react";
import { BRAND, NAV, SERVICES } from "../mock/mock";
import { useContent } from "../context/ContentContext";
import kerberosPng from "../kerberos-certified-v2.png";

export default function Footer() {
  const { brand = BRAND, nav = NAV, services = SERVICES } = useContent();
  return (
    <footer className="relative bg-[#0a0a0a] border-t border-[#B87333]/15 pt-20 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14">
          <div className="md:col-span-4 space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <img src={brand.logoUrl} alt="AR" className="h-14 w-auto" />
              <div className="flex flex-col">
                <span className="text-[#f5ede1] font-serif-display text-xl tracking-wide">AR DANIŞMANLIK A.Ş.</span>
              </div>
            </Link>
            <p className="text-[#a89a85] leading-relaxed text-sm max-w-sm">
              Yatırım teşvik ve danışmanlık alanında uzman kadromuzla, işletmenizin geleceğini birlikte şekillendirmek için buradayız.
            </p>
            <div className="flex gap-3">
              {[
                { icon: Linkedin, href: brand.socials.linkedin },
                { icon: Instagram, href: brand.socials.instagram },
                { icon: Twitter, href: brand.socials.twitter }
              ].map(({ icon: Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  className="w-10 h-10 border border-[#B87333]/30 flex items-center justify-center text-[#f5ede1] hover:bg-[#B87333] hover:text-[#0a0a0a] transition-colors duration-300"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[11px] tracking-[0.3em] text-[#B87333] mb-5">MENÜ</h4>
            <ul className="space-y-3">
              {nav.map((n) => (
                <li key={n.path}>
                  <Link to={n.path} className="text-sm text-[#f5ede1] hover:text-[#B87333] transition-colors">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] tracking-[0.3em] text-[#B87333] mb-5">HİZMETLER</h4>
            <ul className="space-y-3">
              {services.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/hizmet/${s.slug}`}
                    className="text-sm text-[#a89a85] hover:text-[#B87333] transition-colors flex items-start gap-1"
                  >
                    <ArrowUpRight className="w-3 h-3 mt-1 flex-shrink-0" />
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] tracking-[0.3em] text-[#B87333] mb-5">İLETİŞİM</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#B87333] mt-0.5 flex-shrink-0" />
                <span className="text-[#a89a85] leading-relaxed">{brand.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#B87333] flex-shrink-0" />
                <a href={`tel:${brand.phoneRaw}`} className="text-[#f5ede1] hover:text-[#B87333]">{brand.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#B87333] flex-shrink-0" />
                <a href={`mailto:${brand.email}`} className="text-[#f5ede1] hover:text-[#B87333]">{brand.email}</a>
              </li>
            </ul>
            <div className="mt-6">
              <a
                href="https://kerberos.tr/certified.php"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
              >
                <img
                  src={kerberosPng}
                  alt="Kerberos Sertifikalı"
                  className="h-16 w-auto object-contain"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#B87333]/15 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-[#6d6355] tracking-wide">
            © {new Date().getFullYear()} {brand.name} | Proudly powered by <a href="https://www.kerberos.tr" target="_blank" rel="noopener noreferrer" className="hover:text-[#B87333] transition-colors">KERBEROS</a>
          </p>
          <p className="text-xs text-[#6d6355] tracking-[0.2em]">AR DANIŞMANLIK A.Ş.</p>
        </div>
      </div>
    </footer>
  );
}
